import React, { ReactElement, useEffect } from "react"
import Select, { SingleValue } from "react-select"
import { FormLabel, TextArea, TextInput } from "@wfp/ui"
import { IChoiceOption, IChoices } from "interfaces/xlsForm"
import { useGetChoicesOptionQuery } from "services/household/xlsFormSchemas"

type Props = {
  xlsFormId: number
  form: IChoiceOption
  setForm: React.Dispatch<React.SetStateAction<IChoiceOption>>
  currentList: SingleValue<IChoices>
}

const ChoiceForm = ({ xlsFormId, form, setForm, currentList }: Props): ReactElement => {
  const { data: choiceList, isLoading } = useGetChoicesOptionQuery({ xlsFormId }, { skip: !xlsFormId })

  const customStyles = {
    option: (styles, { data, isFocused }) => ({
      ...styles,
      backgroundColor: isFocused ? "#EBF3FB" : "#fff",
      color: !data.choices?.length ? "var(--support-01)" : "#000",
    }),
  }

  useEffect(() => {
    currentList && setForm(prev => ({ ...prev, choiceListId: currentList.listId }))
  }, [currentList])

  return (
    <div className="flex flex-col gap-4">
      <div>
        <FormLabel htmlFor="choice-list" className="required">
          Choice list
        </FormLabel>
        <Select
          inputId="choice-list"
          styles={customStyles}
          isLoading={isLoading}
          placeholder="Select choice list"
          options={choiceList || []}
          getOptionLabel={option => option.listName}
          getOptionValue={option => option.listId?.toString()}
          value={choiceList?.flatMap(item => item.options)?.find(option => option.listId === form.choiceListId)}
          onChange={item => setForm(prev => ({ ...prev, choiceListId: item?.listId ?? 0 }))}
          formatOptionLabel={option => (
            <div className="flex items-center justify-between">
              <div>{option.listName}</div>
              <div className="text-xs">{option.choices?.length}</div>
            </div>
          )}
          isSearchable
          isClearable
        />
      </div>

      <TextInput
        labelText="Name"
        name="name"
        formItemClassName="text-required"
        className="custom-text-field"
        onChange={e => setForm(prev => ({ ...prev, name: e.target.value }))}
      />
      <TextArea
        labelText="Label"
        name="label"
        // @ts-ignore
        formItemClassName="text-required"
        className="custom-text-field"
        style={{ resize: "none" }}
        rows={3}
        onChange={e => setForm(prev => ({ ...prev, label: e.target.value }))}
      />
    </div>
  )
}

export default ChoiceForm
